import { giftCodeExperienceURL } from 'endpoints';
import fetch from '../utils/fetch';
import { startLoading, endLoading, setAlertMessage } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	done: false
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_DONE = 'SET_DONE';
export const REDEEM_MESSAGE = 'REDEEM_MESSAGE';

/*******************************************************************************
 * Reducer
 */
export default function RedeemGiftCodePage( state = initialState, action ) {
	switch ( action.type ) {
		case REDEEM_MESSAGE:
			return {
				...state,
				catalogUrl: action.data.catalogUrl
			};

		case SET_DONE:
			return {
				...state,
				done: action.done
			};

		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */

export function redeemCode( giftCode ) {
	return ( dispatch ) => {
		dispatch( redeemMessage( { message: [] } ) );
		dispatch( startLoading() );

		return fetch( `${ giftCodeExperienceURL }/getCatalogUrl/${ giftCode }`, {
			method: 'GET',
			headers: { 'content-type': 'application/json' }
		} ).then( ( res ) => {
			if ( res.ok ) {
				res.json().then( ( response ) => {
					dispatch( setDone( true ) );
					if ( response ) {
						dispatch( redeemMessage( response ) );
						dispatch( endLoading() );
					} else {
						let errorMessage = 'Error getting catalogUrl';
						if ( response.errors && response.errors.length > 0 ) {
							errorMessage = response.errors[ 0 ].message;
							if ( !errorMessage.includes( 'giftCode.error' ) ) {
								errorMessage = 'giftCode.error.unknownError';
							}
						}
						dispatch( setAlertMessage( errorMessage, 'DANGER' ) );
						dispatch( endLoading() );
					}
				} );
				return res;
			} else {
				res.json().then( ( response ) => {
					let errorMessage = 'giftCode.error.unknownError';
					dispatch( setAlertMessage( errorMessage, 'DANGER' ) );
					dispatch( endLoading() );
				} );
			}
		} ).catch( ( err )=> {
			dispatch( setAlertMessage( 'giftCode.error.unknownError', 'DANGER' ) );
			dispatch( endLoading() );
			console.error( err );
		} );
	};
}

export function setDone( done ) {
	return {
		type: SET_DONE,
		done
	};
}

export function redeemMessage( data ) {
	return {
		type: REDEEM_MESSAGE,
		data
	};
}